export default __webpack_public_path__ + "static/media/rings.483cf40d.svg";